import { exportRowsToCsv } from "./dashboardsExport";
import { fetchAttritionRecords } from "./dashboardsReactQuery";
import type { AttritionRecord, AttritionRecordsParams } from "./attritionTypes";

export const ATTRITION_EXPORT_PAGE_SIZE = 100;

export function buildAttritionCsvFilename(
  params: Pick<AttritionRecordsParams, "dateStart" | "dateEnd" | "outcome" | "reason">,
): string {
  const reason = params.reason
    ?.trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const reasonSuffix = reason ? `-${reason}` : "";
  return `attrition-${params.outcome}${reasonSuffix}-${params.dateStart}-to-${params.dateEnd}.csv`;
}

export function attritionRecordsToCsvRows(
  records: AttritionRecord[],
): Array<Record<string, unknown>> {
  return records.map((record) => ({
    "Carespace ID": record.carespaceId,
    Carespace: record.carespaceName || "Carespace",
    Clinic: record.clinic,
    Outcome: record.outcome,
    "Pending unalignment PAF": record.hasPendingUnalignmentPaf ? "Yes" : "No",
    "Effective date": record.effectiveDate,
    "Reason category": record.reasonCategory,
    "Source rationale": record.sourceRationale,
    "Activity title": record.activityTitle,
    Narrative: record.narrative,
    "Recorded by": record.recordedBy,
    "Carespace URL": record.carespaceUrl,
  }));
}

export async function fetchAllAttritionRecords(
  params: AttritionRecordsParams,
): Promise<AttritionRecord[]> {
  const rows: AttritionRecord[] = [];
  let offset = 0;
  let totalCount = Number.POSITIVE_INFINITY;

  while (offset < totalCount) {
    const page = await fetchAttritionRecords({
      ...params,
      limit: ATTRITION_EXPORT_PAGE_SIZE,
      offset,
    });
    rows.push(...page.rows);
    totalCount = Math.max(page.totalCount, rows.length);
    if (!page.rows.length) break;
    offset += page.rows.length;
  }

  return rows;
}

export async function downloadAttritionRecordsCsv(params: AttritionRecordsParams): Promise<void> {
  const records = await fetchAllAttritionRecords(params);
  if (!records.length) return;

  await exportRowsToCsv(attritionRecordsToCsvRows(records), buildAttritionCsvFilename(params));
}
